export default function ComparePage() {
  const rows = [
    { feature: '资产归属', spot: '直接持有资产', contract: '持有仓位合约' },
    { feature: '方向限制', spot: '仅能做多', contract: '可做多也可做空' },
    { feature: '杠杆倍数', spot: '无杠杆', contract: '支持多倍杠杆' },
    { feature: '清算机制', spot: '无清算风险', contract: '保证金不足触发强平' },
    { feature: '费用结构', spot: '仅交易手续费', contract: '手续费加资金费率' },
    { feature: '适用目标', spot: '长期持有资产', contract: '短期趋势交易' },
  ]

  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">合约与现货交易对比</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            从六个关键维度理解现货和合约交易的差异。
          </p>
        </div>

        <div className="overflow-x-auto cyber-card p-0" data-unique-module="trading-type-comparison">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-cyber-border">
                <th className="text-left py-4 px-4 text-cyber-text font-semibold font-mono text-sm">对比维度</th>
                <th className="text-left py-4 px-4 text-cyber-text font-semibold font-mono text-sm">现货交易</th>
                <th className="text-left py-4 px-4 text-cyber-text font-semibold font-mono text-sm">合约交易</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className="border-b border-cyber-border/50 hover:bg-accent/5 transition-colors">
                  <td className="py-4 px-4 text-cyber-text font-medium">{row.feature}</td>
                  <td className="py-4 px-4 text-muted">{row.spot}</td>
                  <td className="py-4 px-4 text-muted">{row.contract}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 p-6 cyber-card">
          <h2 className="text-lg font-semibold text-cyber-text mb-3">如何选择</h2>
          <p className="text-muted leading-relaxed text-sm">
            现货交易适合希望在较长周期内持有资产、不关注短期价格波动的投资者。合约交易适合有一定市场经验、能够管理杠杆风险的交易者。选择适合自己的交易类型之前，建议先了解每种机制下的风险边界。
          </p>
        </div>
      </div>
    </div>
  )
}
